import NomacStep from './nomacStep'

export default NomacStep
